import * as React from 'react';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import PlatformConditional from 'Components/PlatformConditional';
import { FormattedMessage } from 'react-intl';

const NerveUltrasoundForm = ({ formData }: IOwnProps): React.JSX.Element => {
  return (
    <React.Fragment>
      <FormRow title="general.date">
        <InputHandler
          type="PartialDate"
          editing={true}
          name="date"
          formData={formData}
          dateDefault="now"
          isNotCancellable={true}
        />
      </FormRow>

      <PlatformConditional platform="polyneuro">
        <FormRow title="imaging.polyneuro.interpretation">
          <InputHandler
            type="Radio"
            editing={true}
            name="interpretation"
            options={['supportsNeuropathy', 'doesNotSupportNeuropathy', 'unknown']}
            optionFormatter={o => <FormattedMessage id={'imaging.polyneuro.opts.' + o} />}
            formData={formData}
          />
        </FormRow>
      </PlatformConditional>
    </React.Fragment>
  );
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'nerveUltrasound'>>;
}

export default NerveUltrasoundForm;
